import * as actions from "./actions";

export default function cruiseReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_CRUISE_SUCCESS:
    case actions.GET_CRUISE_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
